import { useTranslation } from "react-i18next";

import { IconTrash01 } from "@pentabd/icons";
import { Button, Text } from "@pentabd/ui";

import { StatusBadge } from "@components";
import { FileViewOnlyCard } from "@components/FileViewOnlyCard";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { UploadFileType } from "@type/HRM/upload-file";

interface TableColumnPropType {
  onOpen: (id: number | string) => void;
  handleDeleteAction: (id: number | string) => void;
  isProfileDisabled: boolean;
}

export const TableColumn = ({
  onOpen,
  handleDeleteAction,
  isProfileDisabled,
}: TableColumnPropType) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  return [
    {
      id: 1,
      key: "date",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.DATE"),
      render: (date: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {date}
        </Text>
      ),
    },
    {
      id: 2,
      key: "offenceNature",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.REASON_FOR_PUNISHMENT"),
      render: (offenceNature: string) => (
        <Text weight="bold" color="warning">
          {offenceNature}
        </Text>
      ),
    },
    {
      id: 3,
      key: "punishmentDetails",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.PUNISHMENT_DETAILS"),
      render: (punishmentDetails: string) => (
        <Text size="sm" weight="normal" color="subtitle2">
          {punishmentDetails}
        </Text>
      ),
    },
    {
      id: 4,
      key: "remarks",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.REMARKS"),
      render: (remarks: string) => (
        <Text size="sm" weight="normal" color="info">
          {remarks}
        </Text>
      ),
    },
    {
      id: 5,
      key: "isSuspend",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.IS_SUSPEND"),
      render: (isSuspend: boolean, row: any) =>
        isSuspend && !row?.isSuspendEnded ? (
          getAccess(roles, "PUNISHMENT_UPDATE") ? (
            <Button
              fill="outline"
              size="xs"
              type="danger"
              htmlType="button"
              className="p-3 py-0"
              onClick={() => onOpen(row)}
            >
              <IconTrash01 size="16" fill="danger" />
              {t("EMPLOYEE.DISCIPLINE.TABLE.CANCEL_SUSPEND")}
            </Button>
          ) : (
            <StatusBadge status="SUSPENDED" />
          )
        ) : (
          <>--</>
        ),
    },
    {
      id: 6,
      key: "document",
      name: t("EMPLOYEE.DISCIPLINE.TABLE.COLUMN.FILE"),
      render: (document: UploadFileType[]) => (
        // use largeCol prop only if there are so many columns in the table and the file rows breaks
        <FileViewOnlyCard data={document} largeCol />
      ),
    },
    {
      id: 7,
      key: "isSuspend",
      name: "",
      render: (isSuspend: boolean, row: any) =>
        !isSuspend && row?.isSuspendEnded ? (
          getAccess(roles, "PUNISHMENT_UPDATE") && !isProfileDisabled ? (
            <div className="pointer">
              <IconTrash01
                size="24"
                fill="danger"
                onClick={() => handleDeleteAction(row.id)}
              />
            </div>
          ) : undefined
        ) : null,
    },
  ];
};
